import { render, staticRenderFns } from "./AdjustCandidates.vue?vue&type=template&id=0f345f78&"
import script from "./AdjustCandidates.vue?vue&type=script&lang=js&"
export * from "./AdjustCandidates.vue?vue&type=script&lang=js&"
import style0 from "./AdjustCandidates.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f345f78')) {
      api.createRecord('0f345f78', component.options)
    } else {
      api.reload('0f345f78', component.options)
    }
    module.hot.accept("./AdjustCandidates.vue?vue&type=template&id=0f345f78&", function () {
      api.rerender('0f345f78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/adjustCandidates/components/AdjustCandidates.vue"
export default component.exports